import { createAsyncThunk } from '@reduxjs/toolkit';
import apiCall from '../../utils/api';

export const fetchOrgRoles = createAsyncThunk(
  'accessControl/fetchOrgRoles',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall('GET', '/api/organization/system-roles/');
      return (response.data as any).data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch organization roles');
    }
  }
);

export const createOrgRole = createAsyncThunk(
  'accessControl/createOrgRole',
  async (data: { role_name: string; role_description: string }, { rejectWithValue }) => {
    try {
      const response = await apiCall('POST', '/api/organization/system-roles/', data);
      return (response.data as any).data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to create role');
    }
  }
);

export const updateOrgRole = createAsyncThunk(
  'accessControl/updateOrgRole',
  async ({ role_id, data }: { role_id: number; data: any }, { rejectWithValue }) => {
    try {
      const response = await apiCall('PATCH', `/api/organization/system-roles/${role_id}/`, data);
      return (response.data as any).data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to update role');
    }
  }
);

export const fetchSubscribedModules = createAsyncThunk(
  'accessControl/fetchSubscribedModules',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall('GET', '/api/organization/subscribed-modules/');
      return (response.data as any).data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch subscribed modules');
    }
  }
);

export const fetchRoleMappings = createAsyncThunk(
  'accessControl/fetchRoleMappings',
  async (role_id: number, { rejectWithValue }) => {
    try {
      const response = await apiCall('GET', `/api/organization/role-module-mapping/?role_id=${role_id}`);
      return (response.data as any).data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch role mappings');
    }
  }
);

export const saveRoleModuleMapping = createAsyncThunk(
  'accessControl/saveRoleModuleMapping',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await apiCall('POST', '/api/organization/role-module-mapping/', data);
      return (response.data as any).data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to save mapping');
    }
  }
);

export const fetchOrgStaff = createAsyncThunk(
  'accessControl/fetchOrgStaff',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall('GET', '/api/organization/staff/');
      return (response.data as any).data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch staff');
    }
  }
);

export const createOrgStaff = createAsyncThunk(
  'accessControl/createOrgStaff',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await apiCall('POST', '/api/organization/staff/create/', data);
      return (response.data as any).data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to create staff');
    }
  }
);

export const deleteOrgStaff = createAsyncThunk(
  'accessControl/deleteOrgStaff',
  async (mapping_id: number, { rejectWithValue }) => {
    try {
      const response = await apiCall('DELETE', `/api/organization/staff/delete/${mapping_id}/`);
      return (response.data as any).data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to delete staff');
    }
  }
);

export const resetAccessControlActionState = createAsyncThunk(
  'accessControl/resetActionState',
  async () => {
    return null;
  }
);

export const updateOrgStaffStatus = createAsyncThunk(
  'accessControl/updateOrgStaffStatus',
  async (data: { user_id: number; action: 'activate' | 'deactivate' | 'suspend'; remark?: string }, { rejectWithValue }) => {
    try {
      const response = await apiCall('PATCH', '/api/organization/staff/status/', data);
      return (response.data as any).data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to update staff status');
    }
  }
);

export const updateOrgStaffRole = createAsyncThunk(
  'accessControl/updateOrgStaffRole',
  async ({ mapping_id, role_id }: { mapping_id: number; role_id: number }, { rejectWithValue }) => {
    try {
      const response = await apiCall('PATCH', `/api/organization/staff/update/${mapping_id}/`, { role_id });
      return (response.data as any).data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to update staff role');
    }
  }
);
